@if (!authCheckedSignal()) {
  <div class="verifying-wrapper">
    <div class="card p-4 shadow-lg text-center verifying-card">
      <div class="mb-3">
        <i class="bi bi-shield-lock-fill text-primary fs-1"></i>
      </div>
      <h5 class="fw-bold mb-2">Verificando sesión</h5>
      <p class="text-muted mb-3">Un momento por favor...</p>

      <!-- Esto centra horizontalmente el spinner -->
      <div class="d-flex justify-content-center">
        <div class="spinner-border text-primary" role="status"></div>
      </div>
    </div>
  </div>
} @else {
  <router-outlet></router-outlet>
}
